import Button from "./Button"

interface ReleaseUpdateBannerProps {
  available: boolean
  onReload: () => void
}

/** Persistent and user-controlled. Never interrupts a form or steals focus. */
export default function ReleaseUpdateBanner({ available, onReload }: ReleaseUpdateBannerProps) {
  if (!available) return null
  return (
    <div role="status" aria-live="polite" className="shrink-0 border-b border-primary-200 bg-primary-50 px-4 py-3 text-primary-900">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-semibold">En ny versjon av Timebanken er tilgjengelig.</p>
          <p className="text-sm">Lagre eventuelle endringer før du laster siden på nytt.</p>
        </div>
        <Button variant="secondary" size="small" onClick={onReload}>Last inn på nytt</Button>
      </div>
    </div>
  )
}
